// Job chat attachments.
export const chatFileCategories = [
	'bedc:cat:chat:channel-type:internal',
	'bedc:cat:chat:channel-type:external',
	'bedc:cat:chat:channel-type:announcement',
	'bedc:cat:chat:channel-type:review-form-item',
	'bedc:cat:chat:channel-type:bom-item-internal',
	'bedc:cat:chat:channel-type:woh-canvas-internal',
] as const;

// Job files section.
const jobFileCategories = [
	'bedc:cat:supplied',
	'bedc:cat:in-progress',
	'bedc:cat:completed',
	'bedc:cat:archived',
	'bedc:cat:chat',
	'bedc:cat:saas-accounting',
	'bedc:cat:saas-estimator',
	'bedc:cat:saas-only',
] as const;

// Client files section.
const clientFileCategories = ['bedc:category:submitted', 'bedc:category:downloaded'] as const;

// FPC Job
const fpcJobFileCategories = ['bedc:category:original', 'bedc:category:variation'] as const;

export const categories = [
	...jobFileCategories,
	...clientFileCategories,
	...fpcJobFileCategories,
	...chatFileCategories,
] as const;

export const file2FolderIds = [
	'bedc:cat:supplied',
	'bedc:cat:in-progress',
	'bedc:cat:completed',
	...chatFileCategories,
] as const;

export const ids = [...categories] as const;
